import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
import NoAvatar from "../../images/no_avatar.jpg"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteUser, getUsers } from "../../redux/apiCalls"
// Styles
import { Container, GridWrapper, Main, Wrapper, UserColumn, UserImage, StyledLink, StyledButton, StyledIcon, Action, TitleWrapper, Title, TitleButton } from "./UserList.styles"

const UserList = () => {
    const dispatch = useDispatch()
    const users = useSelector((state) => state.user.users)

    useEffect(() => {
        getUsers(dispatch)
    }, [dispatch])

    const handleDelete = (id) => {
        deleteUser(id, dispatch)
    }

    const columns = [
        { field: "_id", headerName: "ID", width: 220 },
        {
            field: "username",
            headerName: "User",
            width: 160,
            renderCell: (params) => {
                return (
                    <UserColumn>
                        <UserImage src={params.row.img || NoAvatar} alt="" />
                        {params.row.username}
                    </UserColumn>
                )
            }
        },
        { field: "email", headerName: "Email", width: 300 },
        {
            field: "isAdmin",
            headerName: "Admin",
            width: 120,
        },
        {
            field: "active",
            headerName: "Active",
            width: 120,
        },
        {
            field: "type",
            headerName: "Type",
            width: 120,
        },
        {
            field: "action",
            headerName: "Action",
            width: 150,
            renderCell: (params) => {
                return (
                    <Action>
                        <StyledLink to={"/user/" + params.row._id}>
                            <StyledButton>Edit</StyledButton>
                        </StyledLink>
                        <StyledIcon>
                            <DeleteOutline
                                onClick={() => handleDelete(params.row._id)}
                                color="secondary"
                            />
                        </StyledIcon>
                    </Action>
                )
            }
        }
    ]

    return (
        <>
            <Topbar />
            <Container>
                <Wrapper>
                    <Sidebar />
                </Wrapper>
                <Main>
                    <TitleWrapper>
                        <Title>Users List</Title>
                        <Link to="/newUser">
                            <TitleButton>Create</TitleButton>
                        </Link>
                    </TitleWrapper>
                    <GridWrapper>
                        <DataGrid
                            rows={users}
                            columns={columns}
                            getRowId={(row) => row._id}
                            disableSelectionOnClick
                            pageSize={8}
                            checkboxSelection
                            autoHeight
                        />
                    </GridWrapper>
                </Main>
            </Container>
        </>
    )
}

export default UserList